import React from 'react';
import { Addon, DiscountRow, Product } from '../OrderForm/types.ts';
import B2BProductCard from '../OrderForm/components/b2b/ProductCard.tsx';
import B2CProductCard from '../OrderForm/components/b2c/ProductCard.tsx';
import { DBProduct, ProductCardVisibility } from '../../types.ts';

import { I18nextProvider } from 'react-i18next';
import i18next from "i18next";
import { createI18nInstance } from '../../../translations/i18n.ts';
import ProductJsonLD from '../ProductJsonLD.tsx';

interface b2bProductsCardProps {
  fieldValues: {
    product: {
      columns: DBProduct;
      id: number;
      table_id: number;
      table_name: string;
    };
    cta_link: string;
    cta_text: string;
    visibility: ProductCardVisibility;
    language: 'en' | 'fi';
  };
  product: Product;
  discountRows: DiscountRow[];
  isb2bProduct: boolean;
  additionalServices: Addon[];
}

function b2bProductCard(props: b2bProductsCardProps) {
  const { fieldValues, product, discountRows, isb2bProduct, additionalServices } = props;
  const language = fieldValues.language;

  const [i18nInstance] = React.useState<typeof i18next>(createI18nInstance(language));

  const contractTemplateId = fieldValues.product.columns.contract_template_id;

  if (!product) {
    return <div>Product not found</div>;
  }
  if (fieldValues.visibility.show_all_variants === false) {
    product.variants = product.variants.filter(variant => variant.contract_template_id === contractTemplateId);
  }

  // TODO: Create component for jsonLd

  return (
    <I18nextProvider i18n={i18nInstance}>
      {isb2bProduct
        ? <B2BProductCard
            product={product}
            horizontal={false}
            actionButtonText={fieldValues.cta_text || "Valitse"}
            buttonLink={fieldValues.cta_link || 'https://www.lumme-energia.fi/tilaa-sopimus'}
            visibility={fieldValues.visibility}
            variantLink={true}
            preSelectedVariantId={contractTemplateId ?? ''}
            discountRows={discountRows}
            onClick={() => { }} />
        : <B2CProductCard
            product={product}
            horizontal={false}
            includeVAT={true}
            buttonLink={fieldValues.cta_link || 'https://www.lumme-energia.fi/tilaa-sopimus'}
            buttonText={fieldValues.cta_text || "Valitse"}
            discountRows={discountRows}
            variantLink={true}
            visibility={fieldValues.visibility}
            preSelectedVariantId={contractTemplateId ?? ''}
            handleClick={() => { }} />
      }
      <ProductJsonLD product={product} variantId={contractTemplateId ?? ''} discountRows={discountRows} additionalServices={additionalServices} />
    </I18nextProvider>
  );
}

export default b2bProductCard;
